import { useMutation } from '@tanstack/react-query';
import useAxios from '../../../app/hooks/useAxios';
import queryClient from '../../../app/utils/queryClient';

const useUserUpdateNotifications = () => {
	const { post } = useAxios();

	const userUpdateNotifications = (notificationTags: string[]) => {
		return post(`/users/me/notifications`, { notificationTags: notificationTags });
	};

	return useMutation(userUpdateNotifications, {
		onSuccess: () => {
			queryClient.invalidateQueries({ predicate: (query) => query.queryKey[0] === 'userProfile' });
		},
	});
};

export default useUserUpdateNotifications;
